import { render, staticRenderFns } from "./caowei.vue?vue&type=template&id=ca7b92e6&scoped=true"
import script from "./caowei.vue?vue&type=script&lang=js"
export * from "./caowei.vue?vue&type=script&lang=js"
import style0 from "./caowei.vue?vue&type=style&index=0&id=ca7b92e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7b92e6",
  null
  
)

export default component.exports